export function isEnvTrue(value) {
  if (typeof value === "string") {
    return value.toLowerCase() === "true" || value === "1";
  }

  return value === true || value === 1;
}
